import React from "react";
import { connect } from "react-redux";
import { setLoader, fetchOrdersAmplify } from "../../actions";
import requireAuth from "../requireAuth";
import AccountNav from "../AccountNav";
import history from "../../history";

class AccountPage extends React.Component {
  componentDidMount = () => {
    const customerEmail = localStorage.email || this.props.auth?.email || '';

    this.props.setLoader(true, "Loading Account...");

    if (customerEmail) {
      this.props.fetchOrdersAmplify(customerEmail, () => {
        this.props.setLoader(false, null);
      });
    } else {
      this.props.setLoader(false, null);
    }
  }

  renderCustomerInfo = () => {
    const firstname = localStorage.first_name || this.props.auth?.first_name || '';
    const lastname = localStorage.last_name || this.props.auth?.last_name || '';
    const email = localStorage.email || this.props.auth?.email || '';
    const mobile = localStorage.mobile || this.props.auth?.mobile || '';

    return (
      <div className="account-card">
        <div className="account-card__header">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="currentColor"/>
          </svg>
          <h3>Customer Information</h3>
        </div>
        <div className="account-card__body">
          <div className="account-card__name">{firstname} {lastname}</div>
          {email && <div className="account-card__detail"><span>Email:</span> {email}</div>}
          {mobile && <div className="account-card__detail"><span>Phone:</span> {mobile}</div>}
        </div>
      </div>
    );
  }

  renderBillingAddress = () => {
    const billingAddress = JSON.parse(localStorage.getItem("billingAddress") || "null");

    return (
      <div className="account-card account-card--half">
        <div className="account-card__header">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 4H4C2.89 4 2 4.89 2 6V18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill="currentColor"/>
          </svg>
          <h3>Billing Address</h3>
        </div>
        <div className="account-card__body">
          {billingAddress ? (
            <>
              <div className="account-card__name">{billingAddress.firstname} {billingAddress.lastname}</div>
              <div className="account-card__detail">{billingAddress.telephone}</div>
              <div className="account-card__detail">{billingAddress.street?.[0] || billingAddress.street}</div>
              <div className="account-card__detail">{billingAddress.city} {billingAddress.region_code} {billingAddress.postcode}</div>
            </>
          ) : (
            <div className="account-card__empty">No billing address saved</div>
          )}
        </div>
      </div>
    );
  }

  renderDefaultShippingAddress = () => {
    const shippingAddress = JSON.parse(localStorage.getItem("selectedShippingAddress") || "null");

    return (
      <div className="account-card account-card--half">
        <div className="account-card__header">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z" fill="currentColor"/>
          </svg>
          <h3>Default Shipping</h3>
        </div>
        <div className="account-card__body">
          {shippingAddress ? (
            <>
              <div className="account-card__name">{shippingAddress.firstname} {shippingAddress.lastname}</div>
              <div className="account-card__detail">{shippingAddress.telephone}</div>
              <div className="account-card__detail">{shippingAddress.street?.[0] || shippingAddress.street}</div>
              <div className="account-card__detail">{shippingAddress.city} {shippingAddress.region_code || shippingAddress.region?.region_code} {shippingAddress.postcode}</div>
            </>
          ) : (
            <div className="account-card__empty">No default shipping address</div>
          )}
        </div>
      </div>
    );
  }

  renderShippingAddresses = () => {
    const addresses = JSON.parse(localStorage.getItem("shippingAddresses") || "[]");

    if (addresses.length === 0) {
      return null;
    }

    return (
      <div className="account-section">
        <h2 className="account-section__title">All Shipping Addresses</h2>
        <div className="account-addresses-grid">
          {addresses.map((v, index) => (
            <div key={v.id || index} className="account-address-card">
              <div className="account-address-card__name">{v.firstname} {v.lastname}</div>
              <div className="account-address-card__detail">{v.telephone}</div>
              <div className="account-address-card__detail">{v.street?.[0] || v.street}</div>
              <div className="account-address-card__detail">{v.city} {v.region_code || v.region?.region_code} {v.postcode}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderOrders = () => {
    if (this.props.orders.length === 0) {
      return (
        <div className="account-card__empty">No orders yet</div>
      );
    }

    return (
      <div className="account-orders-list">
        {this.props.orders.map(v => {
          let grand_total = parseFloat(v.grand_total || 0).toFixed(2);

          return (
            <div className="account-order-card" key={v.id || v.order_id}>
              <div className="account-order-card__header">
                <div className="account-order-card__id">Order #{v.increment_id}</div>
                <div className="account-order-card__total">${grand_total}</div>
              </div>
              <div className="account-order-card__body">
                <div className="account-order-card__customer">{v.customer_name}</div>
                {v.shipping_address && (
                  <div className="account-order-card__address">
                    {Array.isArray(v.shipping_address.street) ? v.shipping_address.street[0] : v.shipping_address.street}
                    {v.shipping_address.city && `, ${v.shipping_address.city}`}
                  </div>
                )}
              </div>
              <button
                className="account-order-card__btn"
                onClick={() => history.push(`/account/order/${v.id || v.order_id}`)}
              >
                View Order
              </button>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    return (
      <div id="page-account" className="account-page">
        <AccountNav />
        <div className="account-content">
          <h1 className="account-title">My Account</h1>

          {this.renderCustomerInfo()}

          <div className="account-section">
            <h2 className="account-section__title">Addresses</h2>
            <div className="account-cards-row">
              {this.renderBillingAddress()}
              {this.renderDefaultShippingAddress()}
            </div>
          </div>

          {this.renderShippingAddresses()}

          <div className="account-section">
            <h2 className="account-section__title">Order History</h2>
            {this.renderOrders()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    orders: state.orders.orders,
    auth: state.auth,
  };
};

export default requireAuth(
  connect(
    mapStateToProps,
    { setLoader, fetchOrdersAmplify }
  )(AccountPage)
);
